function currentYPosition() {
  // Firefox, Chrome, Opera, Safari
  if (window.self.pageYOffset) return window.self.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop) {
    return document.documentElement.scrollTop;
  }
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}
function elmYPosition(eID) {
  var elm = document.getElementById(eID);
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
      node = node.offsetParent;
      y += node.offsetTop;
  } return y;
}
export default function smoothScroll(eID, topOffset) {
  var startY = currentYPosition();
  var stopY = elmYPosition(eID) - topOffset;
  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
      window.scrollTo(0, stopY); return;
  }
  let speed = Math.round(distance / 100);
  if (speed >= 20) speed = 20;
  const step = Math.round(distance / 25);
  let leapY = stopY > startY ? startY + step : startY - step;
  let timer = 0;
  if (stopY > startY) {
      for (let i = startY; i < stopY; i += step) {
          setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
          leapY += step; if (leapY > stopY) leapY = stopY; timer++;
      } return;
  }
  for (let i = startY; i > stopY; i -= step) {
      setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
      leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
  }
}
